* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.title-container {
  .counter {
    padding-left: calc(var(--spacer) / 2);
    color: var(--chart-300-icon-buttons);
  }
  .section-title {
    color: var(--chart-300-icon-buttons);
  }
}

.container {
  height: 30px;
}

gz-tooltip {
  display: block;
}

gz-text[class='trigger-name'],
gz-text[class='event-name'] {
  display: inline;
}

gz-tooltip[class='event-tooltip'] {
  height: 32px;
}

show-more-items-in-bulk {
  padding-bottom: var(--spacer);
}
